import React from 'react';
import StockDisplay from 'components/StockInfo';
import { Flex, MarginBox } from 'UI';

interface CompactStockBadgeProps {
  referenceNumber: string;
}

export const CompactStockBadge = ({ referenceNumber }: CompactStockBadgeProps) => {
  return (
    <Flex maxWidth={50}>
      <MarginBox mx={15}>
        <StockDisplay
          vehicleKey={undefined}
          referenceNumber={referenceNumber}
          isApplicableToCurrentVehicle={undefined}
          small
          spinSize="default"
        />
      </MarginBox>
    </Flex>
  );
};
